// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"657":"4a004e90b01bc0d0c197","693":"db8856ea5dc0e821ce4c","724":"79d5f8840d334379ebd6"}[chunkId] + ".bundle.js";
};